// removed by extract-text-webpack-plugin
module.exports = {"cwPillTriggerFieldTriggerField":"CwPillTriggerField-cwPillTriggerFieldTriggerField"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwpilltriggerfield/CwPillTriggerField.scss
// module id = 376
// module chunks = 0